export default __webpack_public_path__ + "static/full_logo_white-29c25f6c7c232110d224169e2efeb272.svg";